let hiddenKey = 'hidden';
let visibilityChangeKey = 'visibilitychange';
if ('hidden' in document) {
}
else if ('msHidden' in document) {
    hiddenKey = 'msHidden';
    visibilityChangeKey = 'msvisibilitychange';
}
else if ('webkitHidden' in document) {
    hiddenKey = 'webkitHidden';
    visibilityChangeKey = 'webkitvisibilitychange';
}
export default {
    hiddenKey,
    visibilityChangeKey,
};
